import api from './api';

export interface ObjectiveAssignment {
  id: number;
  student: number;
  student_name: string;
  objective: number;
  objective_title: string;
  objective_description: string;
  assigned_date: string;
  status: 'assigned' | 'in_progress' | 'achieved';
  notes: string;
  grade?: number | null;
  achieved_date: string | null;
  created_by: number;
  created_by_name: string;
}

class ObjectiveAssignmentService {
  async getAssignments(params?: any): Promise<ObjectiveAssignment[]> {
    const response = await api.get('/objective-assignments/', { params });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getAssignment(id: number): Promise<ObjectiveAssignment> {
    const response = await api.get(`/objective-assignments/${id}/`);
    return response.data;
  }

  async create(data: Partial<ObjectiveAssignment>): Promise<ObjectiveAssignment> {
    const response = await api.post('/objective-assignments/', data);
    return response.data;
  }

  async update(id: number, data: Partial<ObjectiveAssignment>): Promise<ObjectiveAssignment> {
    const response = await api.patch(`/objective-assignments/${id}/`, data);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/objective-assignments/${id}/`);
  }

  async markAchieved(id: number): Promise<ObjectiveAssignment> {
    const response = await api.post(`/objective-assignments/${id}/mark_achieved/`);
    return response.data;
  }

  async updateStatus(id: number, status: string): Promise<ObjectiveAssignment> {
    const response = await api.post(`/objective-assignments/${id}/update_status/`, { status });
    return response.data;
  }

  async updateGrade(id: number, grade: number | null): Promise<ObjectiveAssignment> {
    const response = await api.patch(`/objective-assignments/${id}/`, { grade });
    return response.data;
  }

  async assignObjectives(studentId: number, objectiveIds: number[]): Promise<ObjectiveAssignment[]> {
    const response = await api.post('/objective-assignments/assign_objectives/', {
      student_id: studentId,
      objective_ids: objectiveIds
    });
    return response.data;
  }
}

const objectiveAssignmentService = new ObjectiveAssignmentService();
export default objectiveAssignmentService;
